import request from 'superagent'
import cookie from 'react-cookies'
import {handleError} from 'common/ErrorHandler'

/**
 * Request builder is used to send HTTP requests to REST services using "superagent" library.
 * The builder accepts method, endpoint and T-VPP logout url as the mandatory arguments.
 * Builder's consumers are able also fill request by parameters, headers, queries etc.
 * When request is filled and ready to be called, {@link RequestBuilder#send} function has to be invoked.
 */
export default class RequestBuilder {

    /**
     * Creates new instance of the builder based on the specified HTTP method, endpoint and T-VPP logout URL.
     * Defines "Authorization" header if access_token is present in session storage.
     * @param method http request method.
     * @param endpoint http endpoint.
     * @param tvppLogoutUrl T-VPP logout URL.
     * @param defaultFailureCallback default callback that has to be executed in case of a failure.
     */
    constructor(method, endpoint, tvppLogoutUrl, defaultFailureCallback) {
        this.req = request(method, endpoint);
        const csrfToken = cookie.load('XSRF-TOKEN');
        if (csrfToken !== null) {
            this.req = this.req.set('X-XSRF-TOKEN', csrfToken);
        }

        this.tvppLogoutUrl = tvppLogoutUrl;
        this.defaultFailureCallback = defaultFailureCallback;
    }

    /**
     * Defines the response data content type for the current instance of request builder.
     * @param contentType type of response data, by default superagent use 'application/json' content type.
     * @returns current instance of the builder.
     */
    contentType(contentType) {
        this.req.accept(contentType);
        return this;
    }

    /**
     * Defines the request parameters for the current instance of request builder.
     * @param parameters HTTP request parameters in JSON format.
     * @returns current instance of the builder.
     */
    params = (parameters) => {
        this.req.send(parameters);
        return this;
    };

    /**
     * Defines the request query for the current instance of request builder.
     * @param query HTTP request query in JSON format.
     * @returns current instance of the builder.
     */
    query = (query) => {
        this.req.query(query);
        return this;
    };

    /**
     * Sends a request to the endpoint.
     * @param successCallback callback that has to be executed in case of a normal response.
     * @param failureCallback callback that has to be executed in case of a failure.
     */
    send = (successCallback, failureCallback) => {
        this.req.end((error, resp) => {
            try {
                if (!error && resp.ok) {
                    successCallback(resp);
                } else if (responseErrorEquals(resp, 'token_expired')) {
                    window.location.href = this.tvppLogoutUrl || '/';
                } else if (responseErrorEquals(resp, 'invalid_token')) {
                    window.location.href = '/';
                } else {
                    let onFailure = failureCallback || this.defaultFailureCallback;
                    onFailure(error, resp);
                }
            } catch (ex) {
                handleError(ex.stack);
                window.location.href = '/errorPage';
            }
        });
    };
}

function responseErrorEquals(response, error) {
    return response && (response.body && response.body.error === error || response.text && response.text.indexOf(error) >= 0);
}



// WEBPACK FOOTER //
// ./src/common/RequestBuilder.js